// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file chat/v3/chat.proto (package chat.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Prompt } from "./chat_prompt_pb";
import { file_chat_v3_chat_prompt } from "./chat_prompt_pb";
import type { Message as Message$1 } from "./chat_messages_pb";
import { file_chat_v3_chat_messages } from "./chat_messages_pb";
import type { AuditMetadata } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Recording } from "./chat_recording_pb";
import { file_chat_v3_chat_recording } from "./chat_recording_pb";
import type { Realm } from "../../realm/v3/realm_pb";
import { file_realm_v3_realm } from "../../realm/v3/realm_pb";
import type { LanguageRegion } from "../../i18n/v3/language_regions_pb";
import { file_i18n_v3_language_regions } from "../../i18n/v3/language_regions_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Scope } from "../../query/v3/scope_pb";
import { file_query_v3_scope } from "../../query/v3/scope_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v3/chat.proto.
 */
export const file_chat_v3_chat: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chat_v3_chat_prompt, file_chat_v3_chat_messages, file_common_v3_common, file_chat_v3_chat_recording, file_realm_v3_realm, file_i18n_v3_language_regions, file_google_protobuf_timestamp, file_query_v3_scope]);

/**
 * @generated from message chat.v3.ChatRequest
 */
export type ChatRequest = Message<"chat.v3.ChatRequest"> & {
  /**
   * @generated from field: chat.v3.Prompt prompt = 1;
   */
  prompt: Prompt;
};

/**
 * Describes the message chat.v3.ChatRequest.
 * Use `create(ChatRequestSchema)` to create a new message.
 */
export const ChatRequestSchema: GenMessage<ChatRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 0);

/**
 * @generated from message chat.v3.ChatResponse
 */
export type ChatResponse = Message<"chat.v3.ChatResponse"> & {
  /**
   * @generated from field: repeated chat.v3.Message messages = 2;
   */
  messages: Message$1[];
};

/**
 * Describes the message chat.v3.ChatResponse.
 * Use `create(ChatResponseSchema)` to create a new message.
 */
export const ChatResponseSchema: GenMessage<ChatResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 1);

/**
 * @generated from message chat.v3.StreamRequest
 */
export type StreamRequest = Message<"chat.v3.StreamRequest"> & {
  /**
   * @generated from field: chat.v3.Prompt prompt = 1;
   */
  prompt: Prompt;
};

/**
 * Describes the message chat.v3.StreamRequest.
 * Use `create(StreamRequestSchema)` to create a new message.
 */
export const StreamRequestSchema: GenMessage<StreamRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 2);

/**
 * @generated from message chat.v3.StreamResponse
 */
export type StreamResponse = Message<"chat.v3.StreamResponse"> & {
  /**
   * The ID of the workflow processing this stream
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Message(s) in this response
   *
   * @generated from field: repeated chat.v3.Message messages = 2;
   */
  messages: Message$1[];
};

/**
 * Describes the message chat.v3.StreamResponse.
 * Use `create(StreamResponseSchema)` to create a new message.
 */
export const StreamResponseSchema: GenMessage<StreamResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 3);

/**
 * @generated from message chat.v3.ConversationRequest
 */
export type ConversationRequest = Message<"chat.v3.ConversationRequest"> & {
  /**
   * Format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * The number of most recent messages to fully populate
   *
   * @generated from field: int64 recent_messages_count = 2;
   */
  recentMessagesCount: bigint;
};

/**
 * Describes the message chat.v3.ConversationRequest.
 * Use `create(ConversationRequestSchema)` to create a new message.
 */
export const ConversationRequestSchema: GenMessage<ConversationRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 4);

/**
 * @generated from message chat.v3.ConversationResponse
 */
export type ConversationResponse = Message<"chat.v3.ConversationResponse"> & {
  /**
   * Format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string publication_status = 3;
   */
  publicationStatus: string;

  /**
   * @generated from field: i18n.v3.LanguageRegion language_region = 4;
   */
  languageRegion: LanguageRegion;

  /**
   * @generated from field: common.v3.AuditMetadata audit_metadata = 5;
   */
  auditMetadata?: AuditMetadata;

  /**
   * @generated from field: realm.v3.Realm realm = 6;
   */
  realm?: Realm;

  /**
   * @generated from field: repeated chat.v3.Recording messages = 7;
   */
  messages: Recording[];
};

/**
 * Describes the message chat.v3.ConversationResponse.
 * Use `create(ConversationResponseSchema)` to create a new message.
 */
export const ConversationResponseSchema: GenMessage<ConversationResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 5);

/**
 * @generated from message chat.v3.StreamPlaybackRequest
 */
export type StreamPlaybackRequest = Message<"chat.v3.StreamPlaybackRequest"> & {
  /**
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: float playback_speed = 2;
   */
  playbackSpeed: number;

  /**
   * Format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 3;
   */
  chatId: string;

  /**
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string tenant_id = 4;
   */
  tenantId: string;
};

/**
 * Describes the message chat.v3.StreamPlaybackRequest.
 * Use `create(StreamPlaybackRequestSchema)` to create a new message.
 */
export const StreamPlaybackRequestSchema: GenMessage<StreamPlaybackRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 6);

/**
 * @generated from message chat.v3.StreamPlaybackResponse
 */
export type StreamPlaybackResponse = Message<"chat.v3.StreamPlaybackResponse"> & {
  /**
   * The ID of the workflow processing this stream
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Message(s) in this response
   *
   * @generated from field: repeated chat.v3.Message messages = 2;
   */
  messages: Message$1[];
};

/**
 * Describes the message chat.v3.StreamPlaybackResponse.
 * Use `create(StreamPlaybackResponseSchema)` to create a new message.
 */
export const StreamPlaybackResponseSchema: GenMessage<StreamPlaybackResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 7);

/**
 * @generated from message chat.v3.ListRecentChatsRequest
 */
export type ListRecentChatsRequest = Message<"chat.v3.ListRecentChatsRequest"> & {
  /**
   * Number of chats to return per page (default: 100, max: 1000)
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Optional cursor for pagination (created_at timestamp)
   *
   * @generated from field: string cursor = 2;
   */
  cursor: string;
};

/**
 * Describes the message chat.v3.ListRecentChatsRequest.
 * Use `create(ListRecentChatsRequestSchema)` to create a new message.
 */
export const ListRecentChatsRequestSchema: GenMessage<ListRecentChatsRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 8);

/**
 * @generated from message chat.v3.ListRecentChatsResponse
 */
export type ListRecentChatsResponse = Message<"chat.v3.ListRecentChatsResponse"> & {
  /**
   * @generated from field: repeated chat.v3.ChatSummary chats = 1;
   */
  chats: ChatSummary[];

  /**
   * Cursor for next page (empty if no more pages)
   *
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;

  /**
   * Total count of chats for the user
   *
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;
};

/**
 * Describes the message chat.v3.ListRecentChatsResponse.
 * Use `create(ListRecentChatsResponseSchema)` to create a new message.
 */
export const ListRecentChatsResponseSchema: GenMessage<ListRecentChatsResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 9);

/**
 * @generated from message chat.v3.ChatSummary
 */
export type ChatSummary = Message<"chat.v3.ChatSummary"> & {
  /**
   * Format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: common.v3.AuditMetadata audit_metadata = 3;
   */
  auditMetadata?: AuditMetadata;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * Last modification timestamp
   *
   * @generated from field: google.protobuf.Timestamp modified_at = 5;
   */
  modifiedAt?: Timestamp;
};

/**
 * Describes the message chat.v3.ChatSummary.
 * Use `create(ChatSummarySchema)` to create a new message.
 */
export const ChatSummarySchema: GenMessage<ChatSummary> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 10);

/**
 * @generated from message chat.v3.ImprovePromptRequest
 */
export type ImprovePromptRequest = Message<"chat.v3.ImprovePromptRequest"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from field: query.v3.Scope scope = 2;
   */
  scope: Scope;
};

/**
 * Describes the message chat.v3.ImprovePromptRequest.
 * Use `create(ImprovePromptRequestSchema)` to create a new message.
 */
export const ImprovePromptRequestSchema: GenMessage<ImprovePromptRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 11);

/**
 * @generated from message chat.v3.ImprovePromptResponse
 */
export type ImprovePromptResponse = Message<"chat.v3.ImprovePromptResponse"> & {
  /**
   * @generated from field: string improved_prompt = 1;
   */
  improvedPrompt: string;
};

/**
 * Describes the message chat.v3.ImprovePromptResponse.
 * Use `create(ImprovePromptResponseSchema)` to create a new message.
 */
export const ImprovePromptResponseSchema: GenMessage<ImprovePromptResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 12);

/**
 * Format defines the format of the conversation.
 *
 * @generated from enum chat.v3.Format
 */
export enum Format {
  /**
   * @generated from enum value: FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FORMAT_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: FORMAT_RICH_TEXT = 2;
   */
  RICH_TEXT = 2,
}

/**
 * Describes the enum chat.v3.Format.
 */
export const FormatSchema: GenEnum<Format> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat, 0);

/**
 * ChatService provides methods for creating, continuing, and retrieving
 * conversations.
 *
 * @generated from service chat.v3.ChatService
 */
export const ChatService: GenService<{
  /**
   * Chat creates or advances a conversation by accepting a prompt and
   * returning completed messages.
   *
   * The prompt can be a text or a rich text document. When working in rich-text
   * the message will be returned as a rich-text document. When working in text
   * the message will be returned as a text document which may contain markdown.
   *
   * Operations block until the message is completed.
   *
   * To create a new chat, provide a empty string or zero ID for the
   * parent message (example: "message_00000000000000000000").
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.Chat
   */
  chat: {
    methodKind: "unary";
    input: typeof ChatRequestSchema;
    output: typeof ChatResponseSchema;
  },
  /**
   * Stream creates or advances a conversation by accepting a prompt and
   * streaming updates as messages are completed.
   *
   * The prompt can be a text or a rich text document. When streaming
   * rich-text delta updates may be sent to allow the client render incremental
   * progress until the message (or block) is done. In such cases, the done
   * message will contain the rich-text document with all the updates applied.
   *
   * To create a new chat, provide a empty string or zero ID for the
   * parent message (example: "message_00000000000000000000").
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.Stream
   */
  stream: {
    methodKind: "server_streaming";
    input: typeof StreamRequestSchema;
    output: typeof StreamResponseSchema;
  },
  /**
   * Conversation retrieves a conversation by its ID. Clients may request either
   * a text or a rich text document. Conversations that were in rich-text
   * may be requested as text; however, messages that occurred as text will
   * be returned as text even if the caller asks for rich-text in this
   * request.
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.Conversation
   */
  conversation: {
    methodKind: "unary";
    input: typeof ConversationRequestSchema;
    output: typeof ConversationResponseSchema;
  },
  /**
   * StreamPlayback retrieves a message by its ID and streams it back to the
   * client. This is useful for playback of messages that were previously
   * streamed. The client can specify a playback speed to control how fast the
   * message is played back. The playback speed is a multiplier of the original
   * message speed, where 1.0 is the original speed, 0.5 is half speed, and 2.0
   * is double speed.
   *
   * This method is useful for debugging and demonstration purposes.
   *
   * @generated from rpc chat.v3.ChatService.StreamPlayback
   */
  streamPlayback: {
    methodKind: "server_streaming";
    input: typeof StreamPlaybackRequestSchema;
    output: typeof StreamPlaybackResponseSchema;
  },
  /**
   * ListRecentChats retrieves a paginated list of recent chats for the authenticated user,
   * sorted by most recent first. Returns chat metadata including ID, title,
   * created date, and last modified date.
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.ListRecentChats
   */
  listRecentChats: {
    methodKind: "unary";
    input: typeof ListRecentChatsRequestSchema;
    output: typeof ListRecentChatsResponseSchema;
  },
  /**
   * ImprovePrompt improves a prompt by analyzing the user's input and
   * providing suggestions for improvement.
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.ImprovePrompt
   */
  improvePrompt: {
    methodKind: "unary";
    input: typeof ImprovePromptRequestSchema;
    output: typeof ImprovePromptResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chat_v3_chat, 0);

